let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("4Jbf1"), load("eelW7")]).then(() => parcelRequire('3Z8XG'));